import React, { useState } from 'react';
import SoftTypography from "components/SoftTypography";
import "./style.css";

const TabsComponent = ({ tabsData, activeTab: controlledActiveTab, onTabChange }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(0);

  const activeTab = controlledActiveTab !== undefined ? controlledActiveTab : internalActiveTab;

  const handleChange = (index, disabled) => {
    if (!disabled) {
      if (onTabChange) {
        onTabChange(index);
      } else {
        setInternalActiveTab(index);
      }
    }
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        {tabsData.map((tab, index) => (
          <div
            key={index}
            className={`tab ${activeTab === index ? 'tab-active' : ''} ${tab.disabled ? 'tab-disabled' : ''}`}
            onClick={() => handleChange(index, tab.disabled)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      {tabsData.map((tab, index) => (
        <div
          key={index}
          className={`tab-content ${activeTab === index ? 'tab-content-active' : ''}`}
        >
          <SoftTypography>{tab.content}</SoftTypography>
        </div>
      ))}
    </div>
  );
};


export default TabsComponent;
